// Version : 0.0.2
// Author : VISHAL,ARANVINDHAN,VISHNU
// LastEdit : SHIYAM
// Last ADD : Added command lines here as cellwise
// MODFIED DATE : 05-08-2025

/* eslint-disable import/no-anonymous-default-export */
import EconomicActivityActionTypes from './economicActivity.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	addEconomicActivityDetailsResponse: null,
	updateEconomicActivityDetailsResponse: null,
	getEconomicActivityListResponse: null,
	getEconomicActivityListArr: [],
	fetchEconomicActivityDetailsResponse: null,
	fetchEconomicActivityDetailsArr: [],
	deleteEconomicActivityDetailsResponse: null,
	addEconomicActivityTypeDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/******************** ADD ECONOMIC ACTIVITY DETAILS START *************************/
		case EconomicActivityActionTypes.ADD_ECONOMIC_ACTIVITY_DETAILS_SUCCESS:
			return { ...state, addEconomicActivityDetailsResponse: action.payload };

		case EconomicActivityActionTypes.ADD_ECONOMIC_ACTIVITY_DETAILS_FAILURE:
			return { ...state, addEconomicActivityDetailsResponse: action.payload };

		case EconomicActivityActionTypes.ADD_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED:
			return { ...state, addEconomicActivityDetailsResponse: null };
		/******************** ADD ECONOMIC ACTIVITY DETAILS END *************************/

		/******************** UPDATE ECONOMIC ACTIVITY DETAILS START *************************/
		case EconomicActivityActionTypes.UPDATE_ECONOMIC_ACTIVITY_DETAILS_SUCCESS:
			return { ...state, updateEconomicActivityDetailsResponse: action.payload };

		case EconomicActivityActionTypes.UPDATE_ECONOMIC_ACTIVITY_DETAILS_FAILURE:
			return { ...state, updateEconomicActivityDetailsResponse: action.payload };

		case EconomicActivityActionTypes.UPDATE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateEconomicActivityDetailsResponse: null };
		/******************** UPDATE ECONOMIC ACTIVITY DETAILS END *************************/

		/******************** GET ECONOMIC ACTIVITY DETAILS START *************************/
		case EconomicActivityActionTypes.GET_ECONOMIC_ACTIVITY_LIST_SUCCESS:
			return {
				...state,
				getEconomicActivityListResponse: action.payload,
				getEconomicActivityListArr: docodeHexResponse(
					action.payload,
					'GetEconomicActivityListKey',
				),
			};

		case EconomicActivityActionTypes.GET_ECONOMIC_ACTIVITY_LIST_FAILURE:
			return { ...state, getEconomicActivityListResponse: action.payload };

		case EconomicActivityActionTypes.GET_ECONOMIC_ACTIVITY_LIST_RESPONSE_CHANGED:
			return { ...state, getEconomicActivityListResponse: null };
		/******************** GET ECONOMIC ACTIVITY DETAILS END *************************/

		/******************** FETCH ECONOMIC ACTIVITY DETAILS START *************************/
		case EconomicActivityActionTypes.FETCH_ECONOMIC_ACTIVITY_DETAILS_SUCCESS:
			return {
				...state,
				fetchEconomicActivityDetailsResponse: action.payload,
				fetchEconomicActivityDetailsArr: docodeHexResponse(
					action.payload,
					'FetchEconomicActivityDetailsKey',
				),
			};

		case EconomicActivityActionTypes.FETCH_ECONOMIC_ACTIVITY_DETAILS_FAILURE:
			return { ...state, fetchEconomicActivityDetailsResponse: action.payload };

		case EconomicActivityActionTypes.FETCH_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchEconomicActivityDetailsResponse: null,
				fetchEconomicActivityDetailsArr: [],
			};
		/******************** FETCH ECONOMIC ACTIVITY DETAILS END *************************/

		/******************** DELETE ECONOMIC ACTIVITY DETAILS START *************************/
		case EconomicActivityActionTypes.DELETE_ECONOMIC_ACTIVITY_DETAILS_SUCCESS:
			return { ...state, deleteEconomicActivityDetailsResponse: action.payload };

		case EconomicActivityActionTypes.DELETE_ECONOMIC_ACTIVITY_DETAILS_FAILURE:
			return { ...state, deleteEconomicActivityDetailsResponse: action.payload };

		case EconomicActivityActionTypes.DELETE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteEconomicActivityDetailsResponse: null };
		/******************** DELETE ECONOMIC ACTIVITY DETAILS END **************************/
		default:
			return state;
	}
};
